// src/api/accessSyncApi.js
import { apiClient } from '../utils/apiClient';

// Kuyruktaki görevleri getir (DeviceCommandQueues filtre + sayfa)
export async function fetchTasks(params = {}) {
    const {
        status = '',
        category = 'all',
        commandType = '',
        page = 1,
        pageSize = 50,
        take,
        skip,
        deviceId,
        employeeId,
        groupId,
        search
    } = params;

    return apiClient('access-sync/tasks', {
        method: 'GET',
        queryParams: {
            status,
            category,
            commandType,
            page,
            pageSize,
            take,
            skip,
            deviceId,
            employeeId,
            groupId,
            search
        }
    });
}

// Özet sayaçları + cihaz bazlı dağılımı getir
export async function fetchSummary(params = {}) {
    const { category = 'all', deviceId } = params;
    return apiClient('access-sync/summary', {
        method: 'GET',
        queryParams: { category, deviceId }
    });
}

// Tekil görev detayı getir
export async function fetchTaskDetail(id) {
    return apiClient(`access-sync/tasks/${id}`, { method: 'GET' });
}

// Kuyruğu tetikle ve takılı kalanları uyandır
export async function runOnce(max = 100, deviceId = null) {
    return apiClient('access-sync/run-once', {
        method: 'POST',
        queryParams: { max, deviceId }
    });
}

// Aktif yetki grubu üyeliklerini cihaz kuyruğuna tam eşitle (push-active)
export async function pushActivePermissions({ deviceId = null, groupId = null } = {}) {
    return apiClient('access-sync/push-active', {
        method: 'POST',
        queryParams: { deviceId, groupId }
    });
}

// Hatalıları toplu yeniden kuyruğa al
export async function requeueFailed({ olderThanMinutes = 0, deviceId = null, category = 'all' } = {}) {
    return apiClient('access-sync/requeue-failed', {
        method: 'POST',
        queryParams: { olderThanMinutes, deviceId, category }
    });
}

// Tek bir kaydı yeniden kuyruğa al
export async function requeueTask(id) {
    return apiClient(`access-sync/tasks/${id}/requeue`, { method: 'POST' });
}

// Bekleyen bir kaydı iptal et
export async function cancelTask(id) {
    return apiClient(`access-sync/tasks/${id}/cancel`, { method: 'POST' });
}
